<template>
  <div class="pagination">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :pager-count="prop_page_Count"
      :page-sizes="pageSizes"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="pageInfo.page"
      :page-size="pageInfo.size"
      :total="total"
      :small="small"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  name: "pagination",
  data() {
    return {
      pageInfo: {
        size: this.limit,
        page: this.currentPage,
      },
    };
  },
  props: {
    total: {
      Type: Number,
      default: 0,
    },
    currentPage: {
      Type: Number,
      default: 1,
    },
    limit: {
      Type: Number,
      default: 12,
    },
    small: {
      Type: Boolean,
      default: true,
    },
    prop_page_Count: {
      Type: Number,
      default: 5,
    },
    pageSizes: {
      Type: Array,
      default: function () {
        return [5, 10, 12, 20, 30, 40, 50, 60, 80, 100];
      },
    },
    qryUrlExpand: {
      Type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    //监听aboutdata数据变化
    total(newdata, olddata) {
      this.total = newdata;
    },
  },
  created() {
    this.pageInit();
  },
  methods: {
    queryGetter() {
      let page = parseInt(this.$route.query.page);
      if (!page || page <= 0) {
        page = this.currentPage;
      }
      let size = parseInt(this.$route.query.size);
      if (this.pageSizes.indexOf(size) === -1) {
        size = this.limit;
      }
      this.pageInfo = {
        page: page,
        size: size,
      };
      Object.keys(this.$route.query).forEach((c) => {
        if (c != "page" && c != "size") {
          this.pageInfo[c] = this.$route.query[c];
        }
      });
      // Object.keys(this.qryUrlExpand).forEach((c) => {
      //   this.pageInfo[c] = this.qryUrlExpand[c];
      // });
    },
    querySetter() {
      this.$router.push({
        query: this.pageInfo,
      });
    },
    pageInit() {
      this.queryGetter();
      this.querySetter();
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.querySetter();
      // this.$router.push({
      //   path: this.$route.path,
      //   query: this.pageInfo,
      // });
      //this.$emit("handleCurrentChange", val);
    },
    // size变化
    handleSizeChange(val) {
      this.pageInfo.size = val;
      this.pageInfo.page = 1;
      this.querySetter();
      // this.$router.push({
      //   path: this.$route.path,
      //   query: this.pageInfo,
      // });
      //this.$emit("handleSizeChange", val);
    },
  },
};
</script>
<style scoped>
.pagination {
  margin: 20px 0;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Page2.vue